export const makeExpirationDate = (days)=>days ? {
        type: 'days',
        days
    } : {
        type: 'none'
    };
